import Grid from "@mui/material/Grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faParking,
  faBurn,
  faTint,
  faBolt,
  faWifi,
  faDog,
  faCat,
  faDove,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { ACCEPTED_FILE_TYPES } from "../constants";

export const getHeaders = () => {
  const identityApp = process.env.REACT_APP_IDENTITY_APP || "rentbeets"
  const identityUrl =
    process.env.REACT_APP_IDENTITY_URL || "https://auth.rentbeets.com";
  let key = `${identityApp}user:${identityUrl}:${identityApp}`;

  // TODO get the token from the context and not the localstorage
  let headers = {"Content-Type": "application/json"};
  if (localStorage.getItem(key) !== null) {
    const localToken = localStorage.getItem(key);
    const token = JSON.parse(localToken).access_token;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  } 
  return new Headers(headers);
};

const QueryParameterName = {
  ReturnUrl: "returnUrl",
  Message: "message",
};

export const GetReturnUrl = (state) => {
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get(QueryParameterName.ReturnUrl);
  return (
    (state && state.returnUrl) || fromQuery || `${window.location.origin}/`
  );
};

export const isFileTypeAccepted = (fileType) =>
  ACCEPTED_FILE_TYPES.includes(fileType.split("/")[1]);

export const getIcon = (item, index = 0) => {
  let faIcon = "";
  switch (item) {
    case "GAS":
      faIcon = faBurn;
      break;
    case "WATER":
      faIcon = faTint;
      break;
    case "ELECTRIC":
      faIcon = faBolt;
      break;
    case "INTERNET":
      faIcon = faWifi;
      break;
    case "PARKING":
      faIcon = faParking;
      break;
    case "YES_DOGS":
      faIcon = faDog;
      break;
    case "YES_CATS":
      faIcon = faCat;
      break;
    case "YES":
      faIcon = faDove;
      break;
    case "STAR":
      faIcon = faStar;
      break;
    default:
      return;
  }

  return (
    <Grid item xs={2} key={index || item}>
      <FontAwesomeIcon icon={faIcon} />
    </Grid>
  );
  // Need FontAwesome pro version in order to have the following:
  // - laundry string "ON_SITE" "IN_UNIT" "NOT_AVAILABLE"
  // - safety array "SMOKE_DETECTOR" "CARBON_MONOXIDE" "FIRE_EXTINGUISHER" "DEAD_BOLT"
  // - appliances array MICROWAVE" "REFRIGERATOR" "STOVE" "OVEN" "DISHWASHER" "GARBAGE_DISPOSAL"
  // - twentyFourHourMaintenance bool
};

export const getRatingAverage = (ratings) => {
  if (!ratings || typeof ratings !== "object" || Array.isArray(ratings)) {
    return 0;
  }
  const sum = Object.keys(ratings).reduce(
    (previousValue, currentValue) => ratings[currentValue] + previousValue,
    0
  );

  return Math.floor(sum / Object.keys(ratings).length);
};

export const formatAmount = (value) => {
  if (typeof value == "number") {
    return value;
  }
  return Number(Number(value.replace(",", ".")).toFixed(2).replace(".", ""));
};

export const unFormatAmount = (value) => {
  const string = value.toString();
  return string.substring(0, string.length - 2);
};
